import { useState } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
  type SizeType,
} from '@skyscanner/backpack-web/bpk-component-button';
import {
  BpkSpinner,
  SPINNER_TYPES,
} from '@skyscanner/backpack-web/bpk-component-spinner';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import type { TextStyle } from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { ButtonClick } from '@shared/ui/types';

import STYLES from './CTAButton.module.scss';

const cls = cssModules(STYLES);

type Props = {
  blank?: boolean;
  bold?: boolean;
  disabled?: boolean;
  secondary?: boolean;
  buttonClassName?: string;
  link?: string;
  text: string;
  onClick?: ButtonClick;
  needLoadingState?: boolean;
  dataTestId?: string;
  textStyle?: TextStyle;
  size?: SizeType;
};

const CTAButton = ({
  blank,
  bold,
  buttonClassName,
  dataTestId,
  disabled,
  link,
  needLoadingState,
  onClick,
  secondary,
  size,
  text,
  textStyle,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const onButtonClicked = (props: any) => {
    if (needLoadingState) {
      setLoading(true);
    }
    onClick && onClick(props);
  };

  return (
    <BpkButtonV2
      type={secondary ? BUTTON_TYPES.secondary : BUTTON_TYPES.primary}
      className={cls(loading && 'CTAButton__loading', buttonClassName)}
      href={disabled ? null : link}
      blank={blank}
      onClick={onButtonClicked}
      data-test-id={dataTestId || 'view-deal'}
      disabled={disabled || loading}
      size={size}
    >
      {loading && (
        <span>
          <BpkSpinner
            type={secondary ? SPINNER_TYPES.dark : SPINNER_TYPES.light}
            alignToButton
          />
        </span>
      )}
      <BpkText
        textStyle={textStyle || (bold ? TEXT_STYLES.label1 : TEXT_STYLES.base)}
        className={cls('CTAButton__text')}
      >
        {text}
      </BpkText>
    </BpkButtonV2>
  );
};

export default CTAButton;
